import { render, staticRenderFns } from "./MainContainerDocumentCheck.vue?vue&type=template&id=74034358&scoped=true&"
import script from "./MainContainerDocumentCheck.vue?vue&type=script&lang=js&"
export * from "./MainContainerDocumentCheck.vue?vue&type=script&lang=js&"
import style0 from "./MainContainerDocumentCheck.vue?vue&type=style&index=0&id=74034358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74034358",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
